<div class="w-full my-1">
    <div class="grid grid-cols-4 gap-8 mb-8">
        <mat-label class="flex items-center"> Installed Date </mat-label>
        <mat-form-field class="no-bottom-gap">
            <input matInput [matDatepicker]="pickerTrsvInstalledDate" [(ngModel)]="trsssvForm.installedDate" />
            <mat-datepicker-toggle matIconSuffix [for]="pickerTrsvInstalledDate"></mat-datepicker-toggle>
            <mat-datepicker #pickerTrsvInstalledDate></mat-datepicker>
        </mat-form-field>

        <mat-label class="flex items-center"> Part Number </mat-label>
        <mat-form-field class="no-bottom-gap">
            <input matInput placeholder="" [(ngModel)]="trsssvForm.partNo">
        </mat-form-field>

        <mat-label class="flex items-center"> Size </mat-label>
        <mat-form-field class="no-bottom-gap">
            <input matInput placeholder="" type="number" [(ngModel)]="trsssvForm.sizeIn">
            <span matTextSuffix>inches</span>
        </mat-form-field>

        <mat-label class="flex items-center"> Self Equalizing </mat-label>
        <mat-radio-group class="mb-4" [(ngModel)]="trsssvForm.isSelfEqualize">
            <mat-radio-button value="true" class="mr-4" color="primary">Yes</mat-radio-button>
            <mat-radio-button value="false" color="primary">No</mat-radio-button>
        </mat-radio-group>

        <mat-label class="flex items-center"> Equipment Brand / OEM </mat-label>
        <mat-form-field class="no-bottom-gap">
            <input matInput placeholder="" [(ngModel)]="trsssvForm.equipmentBrand">
        </mat-form-field>

        <mat-label class="flex items-center"> Locked-Open </mat-label>
        <mat-radio-group class="mb-4" [(ngModel)]="trsssvForm.isLockedOpen">
            <mat-radio-button value="true" class="mr-4" color="primary">Yes</mat-radio-button>
            <mat-radio-button value="false" color="primary">No</mat-radio-button>
        </mat-radio-group>

        <mat-label class="flex items-center"> Rating </mat-label>
        <mat-form-field class="no-bottom-gap">
            <input matInput placeholder="" type="number" [(ngModel)]="trsssvForm.ratingPsi">
            <span matTextSuffix>psi</span>
        </mat-form-field>
    </div>

    <div class="flex justify-end">
        <button class="btn btn-primary" [disabled]="disabledSave()" (click)="save()"> {{ isReplace ? 'Save' : 'Update'
            }} </button>
    </div>
</div>